module.exports = __webpack_public_path__ + "static/media/work-icon.f1cae382.png";